import { put, takeEvery } from 'redux-saga/effects';
import {
  fetchAiResponseSuccess,
  fetchAiResponseFailure,
} from 'redux/ai/actions';
import request from 'utils/request';
import urls from 'utils/config';
import AiTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { AI_BASE_URL } = urls || {};

function* fetchAiResponse({ payload: { appId, stageId, prompt, session_id, page, section } }) {
  const url = `${AI_BASE_URL}/AI-Process-Applicants/chat_ai`;

  const response = yield request({
    method: 'post',
    data: {
      app_id: appId,
      stage_id: stageId,
      session_id: session_id || '',
      page: page || '',
      section: section || '',
      prompt: prompt,
    },
    url,
  });
  if (response.success) {
    yield put(
      fetchAiResponseSuccess({
        text: response?.raw?.response?.stringResponse,
        result: {
          metCriteria: response?.raw?.response?.metCandidatesData || [],
          notMetCriteria: response?.raw?.response?.notMetCandidatesData || [],
        },
        criteriaLists: response?.raw?.response?.criteriasList || [],
        type: 'received',
        ...response?.raw?.response
      })
    );
  } else {
    networkErrorHandler(
      response?.statusCode,
      `Failed to Fetch Sample Queries: ${response.message}`
    );
    yield put(fetchAiResponseFailure(response.message));
  }
}

export function* onFetchAiResponse() {
  yield takeEvery(AiTypes.FETCH_AI_RESPONSE_START, fetchAiResponse);
}
